import { render, staticRenderFns } from "./course-outline-units.vue?vue&type=template&id=604eba33&scoped=true&"
import script from "./course-outline-units.vue?vue&type=script&lang=js&"
export * from "./course-outline-units.vue?vue&type=script&lang=js&"
import style0 from "./course-outline-units.vue?vue&type=style&index=0&id=604eba33&lang=scss&scoped=true&deep=true&"
import style1 from "./course-outline-units.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604eba33",
  null
  
)

export default component.exports